import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment,Button, Popup, Input } from "semantic-ui-react";
import AssetList from "./AssetList";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import AssetStore from "../../../app/stores/assetStore";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";

const AssetDashboard: React.FC = () => {
  const assetStore = useContext(AssetStore);
  const {loadAssets, assetsByCode, searchAsset } = assetStore;

  useEffect(() => {
    loadAssets();
  }, []);

  const [term, setTerm] = useState("");
  
  const handleInputChange=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchAsset(event.currentTarget.value);
  }

  if (assetStore.loadingInitial)
    return <LoadingComponent content="Loading Assets" />;

  return (
    <Segment>
      <Grid>
        <Grid.Column width={4}>
          <CSVLink data={assetsByCode} filename={"assets.csv"}>
            <Popup
              content="Download as CSV"
              trigger={<Button icon="download" floated="left" />}
            />
          </CSVLink>
        </Grid.Column>
        <Grid.Column width={4}>
          <Input  type="text" icon="search" placeholder="Search assets" onChange={handleInputChange} value={term}/>
        </Grid.Column>
        <Grid.Column width={5}></Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={`/dailymanagement/asset-create`}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <AssetList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(AssetDashboard);
